const parts = [`button`, `item`, `list`];

const baseStyle = {
  button: {
    color: `heading`,
    backgroundColor: `white`,
  },
  item: {
    color: `heading`,
    fontSize: `sm`,
    transition: `0.2s ease all`,
  },
  list: {
    zIndex: `3`,
  },
};

export const Dropdown = {
  parts,
  baseStyle,
};
